import z from 'zod';

const storeDeliveryCompanySchema = z
  .object({
    delivery_lead_time_policy_id: z.number().nullable().default(null).optional(),
  })
  // TODO sws: 준서님과 함께 살펴보았지만 왜 optional로 두어야 작동하는지 모름
  .optional();

export const storesDeliveryCompaniesProductsSchema = z.array(
  z.object({
    stores_delivery_company_id: z.number(),
    stores_delivery_company_id_en: z.number().nullable().default(null),
    stores_delivery_company_id_jp: z.number().nullable().default(null),
    _: z
      .object({
        store_delivery_company: storeDeliveryCompanySchema,
      })
      .optional(),
  }),
);
